import React from 'react';
import { accent2 } from '../globals/colors';
import styled from 'styled-components';
import { staticUrl } from '../globals/urls';
import { Token } from './Token.style';
import { Svg } from '../Svg';

export var ShipToken = styled(Token).attrs(function () {return {
    children: /*#__PURE__*/React.createElement(Svg, { url: staticUrl('images/boat.svg') })
  };}).withConfig({ displayName: "ShipToken", componentId: "sc-7wn1jg-0" })(["background:", ";"],
accent2);
//# sourceMappingURL=ShipToken.js.map